import {
  IContact,
  IContactData
} from './index'
import {
  Customer,
  ICustomer
} from '../customer'
import {
  ContactWay,
  IContactWay, IContactWayData
} from '../info'
import {IRequestService, IRequestServiceData, RequestService} from "@/entities";

export class Contact implements IContact {
  readonly id: number
  readonly customer?: ICustomer
  readonly value: string
  contact_way?: IContactWay[]

  constructor(data: IContactData) {
    this.id = data.id
    let customer = data.customer
    this.customer = customer ? new Customer(customer) : undefined
    this.value = data.value
    this.contact_way = data.contact_way?.map((way: IContactWayData) => new ContactWay(way))
  }

  get contact_ways(): string {
    let ways = this?.contact_way?.reduce((res: string, way: IContactWay, index: number) => {
      return res + (index === 0 ? '' : ', ') + way.name
    }, '') || '';
    return ways ? (ways.slice(0, 1).toUpperCase() + ways.slice(1) + '.') : ''
  }

  validate(): boolean {
    return true
  }

  update(data?: IContactData): void {
    data?.contact_way?.forEach((item: IContactWayData) => {
      let ways = this.contact_way
      let way = ways?.find((i: IContactWay) => i.id === item.id)
      if (way) {
        way.update(item)
      } else {
        ways = ways || [];
        ways.push(new ContactWay(item))
      }
    });
  }

}